import React from "react";
import { Link } from "react-router-dom";
import { Phone, WhatsappLogo, EnvelopeSimple, MapPin } from "@phosphor-icons/react";
import { useLang } from "../../context/LanguageContext";
import { mediaUrl } from "../../lib/api";
import { Reveal, Kicker } from "./Reveal";

export const Contact = ({ content }) => {
  const { t } = useLang();
  const c = content?.contact || {};
  return (
    <footer id="contact" className="relative bg-taxi pt-24 md:pt-32 pb-10" data-testid="contact-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal><Kicker>{t("contact_kicker")}</Kicker></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display text-black text-6xl md:text-[9vw] lg:text-9xl uppercase leading-[0.85] mb-14">
            {t("contact_title")}
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-black/20 border border-black/20 mb-16">
          <a href={`tel:${(c.phone1 || "").replace(/[^0-9+]/g, "")}`} className="bg-ink p-8 hover:bg-surface transition-colors group" data-testid="contact-phone1">
            <Phone size={28} weight="fill" className="text-taxi mb-4" />
            <div className="text-white/40 text-xs uppercase tracking-widest mb-1">{t("phone")}</div>
            <div className="text-white font-bold text-xl group-hover:text-taxi transition-colors">{c.phone1}</div>
            <div className="text-white/60 text-lg mt-1">{c.phone2}</div>
          </a>
          <a href={`https://wa.me/${c.whatsapp || ""}`} target="_blank" rel="noreferrer" className="bg-ink p-8 hover:bg-surface transition-colors group" data-testid="contact-whatsapp">
            <WhatsappLogo size={28} weight="fill" className="text-[#25D366] mb-4" />
            <div className="text-white/40 text-xs uppercase tracking-widest mb-1">{t("whatsapp")}</div>
            <div className="text-white font-bold text-xl group-hover:text-[#25D366] transition-colors">{c.phone1}</div>
          </a>
          <a href={`mailto:${c.email || ""}`} className="bg-ink p-8 hover:bg-surface transition-colors group break-words" data-testid="contact-email">
            <EnvelopeSimple size={28} weight="fill" className="text-taxi mb-4" />
            <div className="text-white/40 text-xs uppercase tracking-widest mb-1">{t("email")}</div>
            <div className="text-white font-bold text-base group-hover:text-taxi transition-colors break-all">{c.email}</div>
          </a>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-6 border-t border-black/20 pt-8">
          <div className="flex items-center gap-3">
            <img src={mediaUrl(content?.logo)} alt="MY TAXI" className="h-12 w-12 object-contain rounded-full ring-1 ring-black/10" />
            <span className="font-display text-2xl text-black">MY <span className="text-usared">TAXI</span></span>
          </div>
          <div className="flex items-center gap-2 text-black/70 text-sm font-semibold">
            <MapPin size={16} weight="fill" className="text-black" /> Long Island • All United States
          </div>
          <div className="text-black/60 text-xs">
            © {new Date().getFullYear()} MY TAXI. {t("rights")}{" "}
            <Link to="/admin" className="hover:text-usared underline transition-colors" data-testid="footer-admin-link">{t("admin")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
